import styled from 'styled-components';
import { Button } from '@/components/button';
export const StyledAdvancedFiltersButton = styled(Button) `
    margin-left: 1rem;
    visibility: ${(props) => (props.$hidden ? 'hidden' : 'visible')};
    align-self: center;
`;
